export default __webpack_public_path__ + "static/media/LogoTran.4760e0e2.svg";